import { useCallback, useEffect, useRef } from 'react';
import { useDrumContext } from '../../../contexts/DrumContext';
import { useInterval } from '../../../hooks';
import { useDrumHits } from '../../../hooks/midi';
export function useRecorder(clock, clockState, evaluator, messagesRef, practiceMode) {
    const enabled = practiceMode == 'recording';
    const { drum } = useDrumContext();
    const evaluationCursorRef = useRef(0);
    const evaluatePassedTick = useCallback(() => {
        if (!enabled) {
            return;
        }
        if (clockState.isRunning) {
            const position = evaluator.timing.closestPosition(clock.now);
            if (position.absTick > evaluationCursorRef.current) {
                evaluator.evaluateTick(evaluationCursorRef.current++);
            }
        }
    }, [clock, clockState, enabled, evaluator]);
    useInterval(evaluatePassedTick, enabled ? 25 : null);
    useDrumHits(clock, enabled ? evaluator.push : undefined, enabled ? messagesRef : undefined);
    useEffect(() => {
        if (enabled) {
            const reset = () => {
                evaluationCursorRef.current = 0;
            };
            clock.addEventListener('reset', reset);
            return () => {
                clock.removeEventListener('reset', reset);
            };
        }
    }, [clock, enabled, evaluator]);
    const getRecording = useCallback(() => {
        return {
            endTimestamp: clock.now,
            drumModule: drum?.module, drumConfig: drum?.config,
            hits: evaluator.hits,
            evaluation: evaluator.evaluation
        };
    }, [clock, drum, evaluator]);
    return { getRecording };
}
//# sourceMappingURL=recorder.js.map